<template>
    <space-theme-picker v-model="theme" :label="false"/>
</template>

<script>
import { mapState } from 'vuex';
import SpaceThemePicker from './SpaceThemePicker.vue';
import { copy } from '../../utils/helpers';

export default {
    name: 'SpaceSettingsTheme',
    components: { SpaceThemePicker },
    props: ['space'],
    computed: mapState('spaces', ['update']),
    data() {
        return { theme: copy(this.space.theme) };
    },
    watch: {
        theme(theme) {
            this.$store.dispatch('spaces/update', { space_id: this.space.id, data: { theme } });
        },
    },
};
</script>
